<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :config="config"
    :modals="modals"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('n_process')" name="0" />
        <TabPane :label="$t('y_process')" name="1" />
      </Tabs>
    </template>
    <template #DETAILS="{visible,params}">
      <Tracker v-if="visible" :statusId="params.row.order_sequence"></Tracker>
    </template>
  </cTable>
</template>

<script>
import {
  getTmsWarehouse,
  getWaitList,
  getCycles,
  getStatus
} from "@/api/order/wait_error";
import { getUser } from "@/api/user/internal";
import { getAllClient } from "@/api/user/client";

import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";

export default {
  name: "waitError",
  components: {
    cTable,
    Tracker
  },
  methods: {
    handleTab() {
      this.$refs["table"].resize();
      this.$refs["table"].getList(1);
      this.$refs["table"].getTable().recalculate(true);
    }
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country") {
        item.options = (await getTmsWarehouse()).data.payload;
        this.$refs["table"].$refs["header"].searchForm.country =
          item.options[0].value;
      }
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
      if (item.key === "type") item.options = (await getCycles()).data.payload;
      if (item.key === "status")
        item.options = (await getStatus()).data.payload;
    });
  },
  data() {
    return {
      tabName: "0",
      methods: {
        list: async p => {
          // console.log(p);
          p.is_submit = Number(this.tabName);
          let table = this.$refs["table"];
          // if (!table.isOne) {
          //   let res = await table.handleRequestMethods("getTmsWarehouse");
          //   p.country = res.payload[0];
          //   table.isOne = true;
          // }
          return getWaitList(p);
        },
        getTmsWarehouse,
        getAllClient
      },
      modals: {
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        }
      },
      config: {
        height: 630
      },
      header: {
        searchs: [
          {
            key: "country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryCode");
            },
            options: [],
            clearable: false
          },
          {
            key: "clientId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "service_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("cycle");
            },
            options: [],
            config: {
              label: "name",
              value: "value"
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("process_status");
            },
            show: () => this.tabName == "1",
            options: [],
            config: {
              label: "name",
              value: "value"
            }
          },
          {
            key: "service_classify",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceType");
            },
            show: () => this.tabName == "0",
            options: [
              {
                label: this.$t("b2bClient"),
                value: 0
              },
              {
                label: this.$t("service"),
                value: 1
              }
            ]
          },
          {
            key: "is_cod",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("fangdan");
            },
            options: [
              {
                label: this.$t("ToPay"),
                value: 1
              },
              {
                label: this.$t("Prepaid"),
                value: 2
              }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
            // add() {
            //   this.getModal("add").open(null, () => {
            //     this.getModal("add").setTitle(this.$t("add"));
            //     this.getModal("add").type = "add";
            //   });
            // }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "order_sequence",
          align: "center",
          width: 150,
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showDetails").setTitle(row.order_sequence);
              this.$page.getModal("showDetails").open({ row });
            }
          }
        },
        {
          name: () => this.$t("onlineTime"),
          key: "create_time",
          align: "center",
          width: 170
        },
        {
          name: () => this.$t("whether") + this.$t("refuse_t"),
          key: "flag",
          align: "center",
          width: 80,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          align: "center"
        },
        {
          name: () => this.$t("process_status"),
          key: "order_status",
          align: "center",
          show: () => this.tabName == "1"
        },
        {
          name: () => this.$t("handle") + this.$t("type"),
          key: "order_type",
          align: "center",
          show: () => this.tabName == "1"
        },
        {
          name: () => this.$t("handle") + this.$t("time"),
          key: "scan_time",
          align: "center",
          width: 170,
          show: () => this.tabName == "1"
        },
        {
          name: () => this.$t("CurrentState"),
          key: "scan_status",
          width: 80,
          align: "center",
          show: () => this.tabName == "1"
        },
        {
          name: () => this.$t("clientName"),
          key: "client",
          align: "center"
        },
        {
          name: () => this.$t("operate"),
          key: "operator",
          align: "center"
        },
        {
          name: () => this.$t("exception_msg"),
          key: "abnormal_msg",
          align: "center",
          show: () => this.tabName == "0"
        },
        {
          name: () => this.$t("serviceType"),
          key: "service_classify",
          align: "center",
          width: 80,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("service") : this.$t("b2bClient");
            }
          }
        },
        {
          name: () => this.$t("Remaining_available") + this.$t("dayNumber"),
          key: "time_left",
          align: "center",
          show: () => this.tabName == "0"
        },
        {
          name: () => this.$t("subplan") + this.$t("time"),
          key: "post_time",
          align: "center",
          width: 170,
          show: () => this.tabName == "1"
        }
      ]
    };
  }
};
</script>
